export var ORDER_STEPS = {
  DOWN_PAYMENT: 1,
  RESERVE_CAR: 2,
  COLLECT_PAYMENT: 3,
  CAR_INSURANCE: 4,
  REGISTER_CAR_NEW: 5,
  REGISTER_CAR_USED: 6,
  READY_FOR_DELIVERY: 7,
  CAR_SHIPPING: 8,
  CAR_RECEPTION: 9
};